module.exports = __webpack_public_path__ + "img/game02.737bef50.png";